import { Col, Form } from 'antd';
import Button from 'mixins/ui/button/button';
import PartWrapper from 'mixins/ui/part-wrapper';
import React, { useEffect, useState } from 'react';
import 'react-app-polyfill/stable';
import ArrowIcon from './arrow.svg';
import { filterDictionary } from '/react4xp/parts/admin-dictionary/actions';

import './RevenueList.scss';
import { getLangValue } from '/react4xp/mixins/helpers';

type Props = {
    selectedItem: any;
    setSelectedItem: (selectedItem: any) => void;
    params: any;
    setParams: (data) => void;
    language: string;
};

const RevenueList: React.FC<Props> = ({
    selectedItem,
    setSelectedItem,
    setParams,
    params,
    language,
}) => {
    const [fieldValues, setFieldValues] = useState<any>();
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState([]);
    const [childrenShow, setChildrenShow] = useState(null);

    const clearForm = () => {
        form.resetFields();
    };

    useEffect(() => {
        const handleReCaptchaVerify = async () => {
            // const recaptchaToken = await executeRecaptcha('reference_book_revenue_list');
            // if (!recaptchaToken) {
            //     return;
            // }

            filterDictionary(
                {
                    dictionaryCode: 'tax_org',
                    page: 0,
                    size: 300,
                },
                {}
            )
                .then(({ data }) => {
                    const lang = getLangValue(language);

                    const level2DictionaryList = [];
                    const level3DictionaryMap = new Map();

                    data.dictionary.forEach((item) => {
                        item.name = item[lang]?.trim();
                        if (!item.name) {
                            item.name = item.ru;
                        }

                        if (item.level === 2) {
                            level2DictionaryList.push(item);
                        } else if (item.level === 3) {
                            if (!level3DictionaryMap.has(item.parent_uid)) {
                                level3DictionaryMap.set(item.parent_uid, []);
                            }
                            level3DictionaryMap.get(item.parent_uid).push(item);
                        }
                    });

                    const res = level2DictionaryList.map((item) => {
                        if (level3DictionaryMap.has(item.uid)) {
                            return {
                                ...item,
                                children: level3DictionaryMap.get(item.uid),
                            };
                        } else {
                            return {
                                ...item,
                                children: [],
                            };
                        }
                    });

                    setData(res);
                })
                .finally(() => setLoading(false));
        };
        handleReCaptchaVerify();
    }, []);

    const selectItem = (item) => {
        setSelectedItem((prevSelectedItem) => {
            const newSelectedItem = item.uid === prevSelectedItem ? null : item.uid;

            setParams({
                level: 2,
                payload: item,
            });
            return newSelectedItem;
        });
    };

    const selectChild = (item) => {
        setSelectedItem((prevSelectedItem) => {
            const newSelectedItem = item.code === prevSelectedItem ? null : item.code;

            setParams({
                level: 3,
                payload: item,
            });
            return newSelectedItem;
        });
    };

    return (
        <>
            <div className="revenue-list">
                <ul>
                    {data.map((item) => (
                        <>
                            <Col className="list-parent">
                                <li
                                    onClick={() => selectItem(item)}
                                    className={item.code === selectedItem ? 'active' : ''}
                                >
                                    {item.name}
                                </li>
                                {item?.children.length > 0 && (
                                    <Button
                                        className="p-0"
                                        shape="default"
                                        style={{
                                            border: 'none',
                                            height: 20,
                                            width: 20,
                                            boxShadow: 'none',
                                        }}
                                        icon={
                                            <ArrowIcon
                                                style={{
                                                    rotate:
                                                        childrenShow == item.code
                                                            ? '0deg'
                                                            : '270deg',
                                                }}
                                            />
                                        }
                                        onClick={() =>
                                            setChildrenShow(
                                                item.code === childrenShow ? null : item.code
                                            )
                                        }
                                    />
                                )}
                            </Col>

                            {childrenShow == item.code && (
                                <ul
                                    style={{
                                        borderBottom: '1px solid #e6e6ef',
                                    }}
                                >
                                    {item.children?.map((c) => (
                                        <li
                                            onClick={() => selectChild(c)}
                                            className={c.code === selectedItem ? 'active' : ''}
                                            style={{
                                                paddingLeft: 30,
                                            }}
                                            key={c.uid}
                                        >
                                            {c.name}
                                        </li>
                                    ))}
                                </ul>
                            )}
                        </>
                    ))}
                </ul>
            </div>
        </>
    );
};

export default (props) => (
    <PartWrapper {...props}>
        <RevenueList {...props} />
    </PartWrapper>
);
